const customFieldsLang = {
  menu: 'Champs personnalisés',
  pageTitle: 'Champs personnalisés',
  new: 'Création d\'un champ personnalisé',
  edit: 'Modification d\'un champ personnalisé',
  deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce champ personnalisé ?',
  label: 'Nom du champ personnalisé',
  typeLabel: 'Type de champ',
  requiredLabel: 'Obligatoire',
  usageLabel: 'Utilisation',
  formTitle: 'Champs personnalisés',
  viewConfig: 'Sur une fiche, afficher les champs personnalisés dans un onglet dédié plutôt qu\'à la suite des autres informations.',

  layout: {
    button: 'Mise en page',
    title: 'Personnalisation de la mise en page des champs personnalisés',
    new: 'Création d\'une mise en page',
    edit: 'Modification d\'une mise en page',
    deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette mise en page ?',
    elementTitle: 'Éléments concernés par la mise en page',
    layoutTitle: 'Mise en page',
    layoutExplain: 'La mise en page ne s\'applique, par défaut, qu\'aux formulaires. Si vous souhaitez appliquer cet affichage aux différentes fiches, vous devez afficher les informations des champs personnalisés dans un onglet dédié et non sur la partie de gauche, à la suite des autres informations.',
    showInTab: 'Afficher les champs personnalisés dans un onglet dédié',
    layoutElement: 'Éléments de mise en page',
    layoutDelete: 'Supprimer l\'élément de mise en page',
    placement: 'Emplacements'
  },

  types: {
    amount: 'Montant',
    checkbox: 'Cache à cocher multiple',
    date: 'Date',
    number: 'Nombre',
    phone: 'Téléphone',
    quantity: 'Quantité',
    radio: 'Cache à cocher unique',
    'rich-editor': 'Éditeur de texte avancé (gras, italique...)',
    select: 'Menu déroulant',
    text: 'Ligne de texte simple',
    textarea: 'Texte simple avec retour à la ligne'
  }
}

export default {
  customFields: customFieldsLang
}
